

<script lang="ts" setup>
import { reactive, watch } from 'vue';

import { QuestionModel } from '../types';
const props = defineProps<{
  question: QuestionModel;
  isChildQuestion?: boolean;
  multiQuestion?: boolean;
  accentColour?: string;
}>();

const emit = defineEmits(['answerChanged']);

const data = reactive({
  model: props.question,
  answer: null as number | null,
  isChildQuestion: props.isChildQuestion,
  accentColour: props.accentColour,
});

watch(
  () => data.answer,
  () => {
    if (data.answer === null) return;
    emit('answerChanged', {
      id: data.model.id,
      answer: data.answer.toString(),
    });
  },
);

const getButtonSize = (total: number) => {
  if (total > 5) {
    return 'w-6 h-6 md:w-10 md:h-10 text-lg md:text-xl';
  } else {
    return 'w-10 h-10 text-xl';
  }
};

const getButtonColors = (isSelected: boolean) => {
  // #edf2f7 = .bg-gray-200
  // #4a5568 = .text-gray-700
  return {
    color: `${isSelected ? '#fff' : '#4a5568'}`,
    'background-color': `${isSelected ? data.accentColour : '#edf2f7'}`,
  };
};
</script>
<template>
  <div class="text-left w-full" :class="data.isChildQuestion ? 'mb-8' : 'mb-16'" v-if="data.model">
    <p class="mb-2 font-bold whitespace-pre-line">
      {{ data.model.questionText }}
      <span v-if="data.model.mandatory && !data.isChildQuestion" class="text-red-500">*</span>
    </p>
    <p>{{ data.model.helperText }}</p>

    <div
      class="flex justify-between items-center mt-8"
      :id="data.model.id"
      v-if="data.model.maximumNumberRatingValue"
    >
      <button
        @click="data.answer = 0"
        v-if="data.model.minimumNumberRatingValue === 0"
        type="button"
        class="rounded-full border flex items-center justify-center font-semibold"
        :class="getButtonSize(data.model.maximumNumberRatingValue)"
        :style="getButtonColors(data.answer === 0)"
      >
        0
      </button>
      <button
        @click="data.answer = n"
        v-for="n in data.model.maximumNumberRatingValue"
        :key="n"
        type="button"
        class="rounded-full border flex items-center justify-center font-semibold"
        :class="getButtonSize(data.model.maximumNumberRatingValue)"
        :style="getButtonColors(data.answer === n)"
      >
        {{ n }}
      </button>
    </div>
    <div
      class="flex justify-between items-center mt-4"
      v-if="data.model.minimumNumberRatingLabel && data.model.maximumNumberRatingLabel"
    >
      <span class="text-sm">{{ data.model.minimumNumberRatingLabel }}</span>
      <span class="text-sm">{{ data.model.maximumNumberRatingLabel }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
button.rounded-full {
  outline: none;
}
</style>
